/**
 * @private
 * @deprecated https://hello.jira.atlassian.cloud/browse/EDITOR-2872
 * To be removed as part of Block menu project release
 */
export const FORMAT_MENU_ITEM = {
	key: 'nested-menu-format-section-primary',
};

/**
 * @private
 * @deprecated
 */
export const NESTED_FORMAT_MENU_SECTION = {
	key: 'nested-menu-format-section-primary',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_HEADING_1_MENU_ITEM = {
	key: 'block-menu-format-heading-1',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_HEADING_2_MENU_ITEM = {
	key: 'block-menu-format-heading-2',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_HEADING_3_MENU_ITEM = {
	key: 'block-menu-format-heading-3',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_HEADING_4_MENU_ITEM = {
	key: 'block-menu-format-heading-4',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_HEADING_5_MENU_ITEM = {
	key: 'block-menu-format-heading-5',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_HEADING_6_MENU_ITEM = {
	key: 'block-menu-format-heading-6',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_PARAGRAPH_MENU_ITEM = {
	key: 'block-menu-format-paragraph',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_QUOTE_MENU_ITEM = {
	key: 'block-menu-format-quote',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_EXPAND_MENU_ITEM = {
	key: 'block-menu-format-expand',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_LAYOUT_MENU_ITEM = {
	key: 'block-menu-format-layout',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_PANEL_MENU_ITEM = {
	key: 'block-menu-format-panel',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_CODE_BLOCK_MENU_ITEM = {
	key: 'block-menu-format-code-block',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_BULLETED_LIST_MENU_ITEM = {
	key: 'block-menu-format-bulleted-list',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_NUMBERED_LIST_MENU_ITEM = {
	key: 'block-menu-format-numbered-list',
};

/**
 * @private
 * @deprecated
 */
export const FORMAT_TASK_LIST_MENU_ITEM = {
	key: 'block-menu-format-task-list',
};

/**
 * @private
 * @deprecated
 */
export const NESTED_FORMAT_MENU = {
	key: 'nested-menu-format',
};

/**
 * @private
 * @deprecated
 */
export const PRIMARY_MENU_SECTION = {
	key: 'block-menu-section-primary',
};

/**
 * @private
 * @deprecated
 */
export const ADD_BLOCKS_MENU_SECTION = {
	key: 'block-menu-section-synced-block',
};

/**
 * @private
 * @deprecated
 */
export const COPY_MENU_SECTION = {
	key: 'block-menu-section-copy',
};

/**
 * @private
 * @deprecated
 */
export const MOVE_UP_DOWN_MENU_SECTION = {
	key: 'block-menu-section-move-up-down',
};

/**
 * @private
 * @deprecated
 */
export const CREATE_SYNCED_BLOCK_MENU_ITEM = {
	key: 'block-menu-create-synced-block',
};

/**
 * @private
 * @deprecated
 */
export const COPY_BLOCK_MENU_ITEM = {
	key: 'block-menu-copy-block',
};

/**
 * @private
 * @deprecated
 */
export const COPY_LINK_MENU_ITEM = {
	key: 'block-menu-item-copy-link',
};

/**
 * @private
 * @deprecated
 */
export const MOVE_UP_MENU_ITEM = {
	key: 'block-menu-item-move-up',
};

/**
 * @private
 * @deprecated
 */
export const MOVE_DOWN_MENU_ITEM = {
	key: 'block-menu-item-move-down',
};
